exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\na[data-v-4eb8a45e] {text-decoration: none;}\n", ""]);

